import { useTitle } from "@/Utilities/Hooks";
import HomeLayout from "@/Layouts/HomeLayout";
import HeroBlock from "@/Components/Blocks/HeroBlock";
import TextBlock from "@/Components/Blocks/TextBlock";
import ContactPersons from "@/Components/Blocks/ContactPersons";
import { Video } from "@/Components/";
import { InertiaLink } from "@inertiajs/inertia-react";
import { Subheader } from "@/Components";
import { Divider } from "@/Components/Divider";
import { Carousel } from "@/Components/Carousel";
import { LogoBoard } from "@/Components/LogoBoard";

const Home = ({}) => {
  useTitle("Home");

  return (
    <>
      <HeroBlock />

      <TextBlock className="bg-white py-16">
        <div className="w-full md:w-1/2">
          <img
            className="mb:mb-0 relative z-[100] m-auto mb-2 sm:h-[410px]"
            src="/images/why.png"
            alt="Emma - WHY"
          />
        </div>
        <div className="relative z-[100] flex w-full flex-col items-start justify-start md:w-1/2">
          <Subheader margin={"mb-4"} className="font-normal">
            WHY EMMA?
          </Subheader>

          <h3 className="text-[20px] font-bold leading-[22px] text-[#363636]">
            Reliable platform created by climate reporters
          </h3>
          <p className="mt-2 mb-4 text-[#363636]">
            Behind Emma you get access to a team full of specialists. You can
            relax, we got your back!
          </p>

          <h3 className="text-[20px] font-bold leading-[22px] text-[#363636]">
            Calculate and measure climate impact
          </h3>
          <p className="mt-2 mb-4 text-[#363636]">
            Gather all your data in one platform and benefit from a more
            efficient data collection.
          </p>

          <h3 className="text-[20px] font-bold leading-[22px] text-[#363636]">
            Accelerate your climate action
          </h3>
          <p className="mt-2 mb-4 text-[#363636]">
            Great impact can be done when everyone is involved instead of just
            one person or a team. With Emma, every team can measure their own
            climate impact and the scope has no limits.
          </p>

          <h3 className="text-[20px] font-bold leading-[22px] text-[#363636]">
            Collect data through the whole value chain
          </h3>
          <p className="mt-2 text-[#363636]">
            With Emma’s built-in calculator you can easily gather a lot of data
            from a large amount of people or companies.
          </p>
        </div>
      </TextBlock>

      <div className="bg-white">
        <TextBlock className="mx-4 max-w-[1024px] bg-[#DDEBFC] py-8 md:mx-auto">
          <div className="mb-8 w-full md:mb-0 md:mr-8 md:w-[30%]">
            <img
              className="mb-2 md:m-auto"
              src="/images/standards.png"
              alt="Standards"
            />
          </div>
          <div className="w-full md:w-[70%]">
            <Subheader margin={"mb-4"} className="font-normal">
              STANDARDS
            </Subheader>
            <h3 className="text-[20px] font-bold text-[#363636]">
              With the help of Emma, you can download the key figures required
              for emission reporting in line with ESG, GHG and GRI.
            </h3>
          </div>
        </TextBlock>
      </div>

      <LogoBoard
        className="bg-white pt-16"
        containerClass="mx-4 max-w-[1024px] pt-8 md:mx-auto"
        title="A few of our climate heroes"
      />

      <Carousel />

      <Divider title="Stays updated" />

      <TextBlock className="bg-white pb-8">
        <div className="flex w-full flex-col items-start justify-start md:w-1/2">
          <Subheader className="font-normal">
            STAYS UPDATED IN A CHANGING INDUSTRY
          </Subheader>

          <h3 className="mb-4 text-[24px] font-bold leading-[130%] text-[#363636]">
            When new regulations appear, Emma stays updated
          </h3>

          <p className="leading-[22px] text-[#363636]">
            We have not yet seen it all, that’s fore sure, but Emma will
            continue to adapt to new directives. With a team full of specialists
            behind Emma we can make sure that there is no need to worry about
            the future.
          </p>
        </div>
        <div className="order-first ml-0 w-full md:order-none md:ml-8 md:w-1/2">
          <img
            className="m-auto mb-2 md:mb-0"
            src="/images/reporting.png"
            alt="Emma - REPORTING"
          />
        </div>
      </TextBlock>

      <TextBlock className="bg-white">
        <div className="flex w-full flex-col items-start justify-start md:w-1/2">
          <Subheader className="font-normal">
            GATHER ALL INFORMATION IN ONE PLACE
          </Subheader>

          <h3 className="mb-4 text-[24px] font-bold leading-[130%] text-[#363636]">
            Collecting and calculating external information has never been
            easier
          </h3>

          <p className="leading-[22px] text-[#363636]">
            With the calculator function you can gather information and data
            from suppliers, costumers, visitors etc. without them needing access
            to the system. You simply create a calculator they can access
            through a link, then Emma will calculate the data for you. This
            makes it easy to calculate your emissions through the whole value
            chain and gather it all in one place.
          </p>
        </div>
        <div className="order-first mr-0 w-full md:mr-8 md:w-1/2">
          <img
            className="m-auto mb-2 md:mb-0"
            src="/images/gather-information.png"
            alt="Emma - GATHER INFORMATION"
          />
        </div>
      </TextBlock>

      <Divider title="Scales after you" />

      <TextBlock className="bg-white pb-8 md:pb-24">
        <div className="flex w-full flex-col items-start justify-start md:w-1/2">
          <Subheader className="font-normal">TEAMWORK</Subheader>

          <h3 className="mb-[10px] text-[20px] font-bold leading-[25px] text-[#363636]">
            Organize your reporting by engaging your whole organization and
            create different teams to measure your total climate impact.
          </h3>

          <p className="mt-2 text-[#363636]">
            This approach will increase the involvement regarding the emission
            impact among the employees. Furthermore, this way of collecting data
            will also save time and increase the quality as the emissions are
            reported where they arise.
            <br />
            <br />
            As a report owner you can follow the whole process. Set up teams,
            activities, reporting frequency and send notifications if activities
            are not reported in time.
            <br />
            <br />
            Various types of statistics are available at all time whether you
            are interested in the whole company emissions or just single teams.
            You can follow the emissions in real time and see the probability of
            meeting the emission budget. This creates an opportunity to take
            action early and increases the possibility to reach your goal.
          </p>
        </div>
        <div className="order-first ml-0 w-full md:order-none md:ml-8 md:w-1/2">
          <img
            className="m-auto mb-2 md:mb-0"
            src="/images/teamwork.png"
            alt="Emma - TEAMWORK"
          />
        </div>
      </TextBlock>

      <Divider title="Customisable" />

      <TextBlock className="bg-white pb-16">
        <div className="flex w-full flex-col items-start justify-start md:w-1/2">
          <Subheader className="font-normal">
            WE WANT YOU TO GROW WITH LITTLE OR NO CLIMATE IMPACT
          </Subheader>

          <h3 className="mb-4 text-[24px] font-bold leading-[130%] text-[#363636]">
            To be able to grow within the boundaries of the Paris agreement,
            relevant analyses and a structured approach is necessary. That’s why
            Emma exists.
          </h3>

          <p className="leading-[22px] text-[#363636]">
            Greenhouse gas emissions must be dramatically reduced. With the
            build in emission budget allocated for your organization you can see
            the maximum level of emissions allowed to reach the Paris agreement
            together with your own trend line and the probability of you meeting
            the Paris agreement. Emma also makes it possible for you to simulate
            different actions to see how they will affect your trend line.
            <br />
            <br />
            This will help you make the right decisions to meet your goal.
          </p>
        </div>
        <div className="order-first mr-0 w-full md:mr-8 md:w-1/2">
          <img
            className="m-auto mb-4 md:mb-0"
            src="/images/customisable.png"
            alt="Customisable Image"
          />
        </div>
      </TextBlock>

      <TextBlock className="angle-top bg-background">
        <div className="flex w-full flex-col items-start justify-start md:w-1/2">
          <Subheader className="font-normal">
            START YOUR EMISSION ACCOUNTING TODAY WITH
          </Subheader>

          <h3 className="mb-[10px] text-[30px] font-bold leading-[25px] text-[#363636] md:text-[48px]">
            Emma
          </h3>

          <p className="mt-2 mb-8 text-[#363636]">
            Regardless of your company size, emission levels, complexity, or
            regulatory impact, Emma is a scalable tool adaptable to your unique
            needs, accelerating your climate action.
          </p>

          <ul>
            <li className="mb-2 mr-2 inline-block rounded-full bg-primary p-4 text-center text-[14px] font-bold leading-none text-white">
              Multiple teams
            </li>
            <li className="mb-2 mr-2 inline-block rounded-full bg-primary p-4 text-center text-[14px] font-bold leading-none text-white">
              Custom emission factor
            </li>
            <li className="mb-2 mr-2 inline-block rounded-full bg-primary p-4 text-center text-[14px] font-bold leading-none text-white">
              Multiple reporters
            </li>
            <li className="mb-2 mr-2 inline-block rounded-full bg-primary p-4 text-center text-[14px] font-bold leading-none text-white">
              Request data from supplier
            </li>
            <li className="mb-2 mr-2 inline-block rounded-full bg-primary p-4 text-center text-[14px] font-bold leading-none text-white">
              Full set GHG database
            </li>
            <InertiaLink href="/plans">
              <li className="mb-2 mr-2 inline-block rounded-full bg-blue p-4 text-center text-[14px] font-bold leading-none text-white">
                And more...
              </li>
            </InertiaLink>
          </ul>
        </div>
        <div className="order-first mt-4 mb-4 w-full md:order-none md:mt-0 md:ml-8 md:mb-0 md:w-1/2">
          <Video video="sign_up"></Video>
        </div>
      </TextBlock>

      <TextBlock className="bg-background py-16" pos="flex-col">
        <div className="self-start">
          <Subheader className="font-normal">
            CONTACT US FOR QUESTIONS OR PRICING
          </Subheader>
        </div>

        <ContactPersons />
        <div className="mt-16 flex  w-full flex-col gap-4 sm:flex-row md:mt-20">
          <InertiaLink
            href="/book-a-demo"
            className="btn max-w-max py-3 px-4 text-[14px] font-bold"
          >
            Book a demo
          </InertiaLink>

          <InertiaLink
            href="/plans"
            className="btn max-w-max py-3 px-4 text-[14px] font-bold"
          >
            Start your emission accounting
          </InertiaLink>
        </div>
      </TextBlock>
    </>
  );
};

Home.layout = (page) => <HomeLayout>{page}</HomeLayout>;

export default Home;
